import { render, staticRenderFns } from "./AddSurvey.vue?vue&type=template&id=05ab44a2&scoped=true"
import script from "./AddSurvey.vue?vue&type=script&lang=js"
export * from "./AddSurvey.vue?vue&type=script&lang=js"
import style0 from "./AddSurvey.vue?vue&type=style&index=0&id=05ab44a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab44a2",
  null
  
)

export default component.exports